import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useNav } from '../../../hooks/useNav';
import { NavItemType } from '../../../types/types';
import NavGroup from './NavGroup';

const Navigation = () => {
  const { nav } = useNav();
  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);

  const navGroups = nav.items.map((item: NavItemType) => {
    return item.type === 'group' ? (
      <NavGroup
        key={item.id}
        setSelectedItems={setSelectedItems}
        setSelectedLevel={setSelectedLevel}
        selectedLevel={selectedLevel}
        selectedItems={selectedItems}
        item={item}
      />
    ) : (
      <Typography key={item.id} variant="h6" color="error" align="center">
        Fix - Navigation Group
      </Typography>
    );
  });

  return (
    <Box
      sx={{
        '& > ul:first-of-type': { mt: 0 },
        display: 'block',
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
